import React from 'react';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import { useL10n } from '@uplift/hooks';
import { useHelpCenterStyles } from './support-page-styles';

type HelpCenterBannerProps = {
  helpCenterUrl: string;
};

export const HelpCenterBanner: React.VFC<HelpCenterBannerProps> = ({ helpCenterUrl }) => {
  const { classes } = useHelpCenterStyles();
  const l10n = useL10n();

  return (
    <Card variant="outlined">
      <CardActionArea
        component="a"
        href={helpCenterUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={classes.bannerInner}
      >
        <Typography variant="subtitle1">
          {l10n.support.browseHelpCenter}
        </Typography>
        <Box className={classes.bannerLinkLabel}>
          <Typography variant="subtitle1" color="secondary" fontWeight={600}>
            {l10n.support.goToHelpCenter}
          </Typography>
          <OpenInNew fontSize="small" color="secondary" />
        </Box>
      </CardActionArea>
    </Card>
  );
};
